var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isFunction } from 'angular';
import { CaptchaController } from '../controllers/captcha-controller';
import { CountryFormController } from '../controllers/country-form-controller';
var contactInformationDictionaryKey = 'ContactInformationTitle';
var missingDeviceDictionaryKey = 'MissingDeviceDetailsTitle';
var pleaseSpecifyTextDictionaryKey = 'PleaseSpecifyText';
var versionInformationDictionaryKey = 'VersionInformation';
var emailDoesntMatchDictionaryKey = 'EmailDoesntMatch';
var checkAtLeastOneOptionDictionaryKey = 'CheckAtLeastOneOption';
var MissingDeviceComponentController = (function (_super) {
    __extends(MissingDeviceComponentController, _super);
    function MissingDeviceComponentController($http, $q, missingDeviceConfiguration, vcRecaptchaService, dictionary) {
        var _this = _super.call(this, vcRecaptchaService, $q) || this;
        _this.$http = $http;
        _this.missingDeviceConfiguration = missingDeviceConfiguration;
        _this.dictionary = dictionary;
        _this.productTypes = [];
        _this.audioConnections = [];
        _this.selectedAudioConnections = [];
        _this.audioConnectionUserText = '';
        _this.productUserTypeText = '';
        _this.pleaseSpecifyLabel = '';
        _this.versionInformationLabel = '';
        _this.emailDoesntMatchWarning = '';
        _this.checkAtLeastOneOptionWarning = '';
        _this.defaultSegmetType = 'default';
        _this.showReCaptcha = false;
        _this.showSimpleMath = false;
        _this.setTranslations();
        return _this;
    }
    MissingDeviceComponentController.prototype.$onInit = function () {
        var _this = this;
        this.loading = true;
        this.missingDeviceConfiguration
            .get()
            .then(function (configuration) {
            _this.configuration = configuration;
            _this.translation = _this.configuration.translations[_this.defaultSegmetType];
            _this.countries = configuration.countries || [];
            _this.fields = configuration.fields || {};
            _this.reCaptchaPublicKey = configuration.reCaptchaPublicKey || '';
            _this.productTypes = configuration.productTypes;
            _this.audioConnections = configuration.supportedAudioConnections;
            _super.prototype.checkGoogleAccessibility.call(_this).then(function () {
                _this.showReCaptcha = true;
            }, function () {
                _this.initSimpleMath();
                _this.showSimpleMath = true;
            });
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    MissingDeviceComponentController.prototype.countrySelected = function (selectedCountryId) {
        CountryFormController.prototype.countrySelected.call(this, selectedCountryId);
    };
    MissingDeviceComponentController.prototype.audioConnectionChecked = function (audioConnectionTitle) {
        var filterIndex = this.selectedAudioConnections.indexOf(audioConnectionTitle);
        if (filterIndex === -1) {
            this.selectedAudioConnections.push(audioConnectionTitle);
        }
        else {
            this.selectedAudioConnections.splice(filterIndex, 1);
        }
        this.validateAudioConnections();
    };
    MissingDeviceComponentController.prototype.isAudioConnectionChecked = function (audioConnectionTitle) {
        return this.selectedAudioConnections.indexOf(audioConnectionTitle) > -1;
    };
    MissingDeviceComponentController.prototype.validateReenterEmail = function () {
        var email = document.getElementById('email');
        var reenterEmail = document.getElementById('reenter-email');
        if (email.value !== reenterEmail.value) {
            reenterEmail.setCustomValidity(this.emailDoesntMatchWarning);
            return false;
        }
        reenterEmail.setCustomValidity('');
        return true;
    };
    MissingDeviceComponentController.prototype.validateAudioConnections = function () {
        var checkboxes = document.getElementsByClassName('audio-connection-option');
        var firstCheckbox = checkboxes ? checkboxes[0] : null;
        var checkboxValidityText = this.selectedAudioConnections.length > 0 ? '' : this.checkAtLeastOneOptionWarning;
        firstCheckbox === null || firstCheckbox === void 0 ? void 0 : firstCheckbox.setCustomValidity(checkboxValidityText);
    };
    MissingDeviceComponentController.prototype.reCaptchaSetResponse = function (response) {
        _super.prototype.reCaptchaSetResponse.call(this, response);
        this.sendData();
    };
    MissingDeviceComponentController.prototype.initSimpleMath = function (callback) {
        var _this = this;
        this.$http.get(this.configuration.simpleMathQuestionEndpoint).then(function (response) {
            _this.simpleMathId = response.data.id || '';
            _this.simpleMathQuestion = response.data.question || '';
            _this.simpleMathUserResult = response.data.userResult || null;
            _this.showSimpleMath = true;
            if (isFunction(callback)) {
                callback();
            }
        });
    };
    MissingDeviceComponentController.prototype.submitForm = function (submitEvent) {
        submitEvent.preventDefault();
        this.showReCaptcha ? this.vcRecaptchaService.execute(this.reCaptchaWidgetId) : this.sendData();
    };
    MissingDeviceComponentController.prototype.sendData = function () {
        var _this = this;
        var captchaModel = _super.prototype.getCaptchaModel.call(this);
        var submitData = {
            captchaModel: captchaModel,
            fieldInputModels: [
                { id: this.fields.firstName.id, value: this.formData.firstName },
                { id: this.fields.lastName.id, value: this.formData.lastName },
                { id: this.fields.company.id, value: this.formData.company },
                { id: this.fields.email.id, value: this.formData.email },
                { id: this.fields.reenterEmail.id, value: this.formData.reenterEmail },
                { id: this.fields.phone.id, value: this.formData.phone },
                { id: this.fields.country.id, value: this.formData.selectedCountry },
                { id: this.fields.state.id, value: this.states.length > 0 ? this.formData.selectedState : null },
                { id: this.fields.yourJabraProduct.id, value: this.formData.yourJabraProduct },
                { id: this.fields.brandOrVendor.id, value: this.formData.brandOrVendor },
                { id: this.fields.productName.id, value: this.formData.productName },
                { id: this.fields.productType.id, value: this.handleProductType() },
                { id: this.fields.supportedAudioConnections.id, value: this.handleSupportedAudioConnections() },
                { id: this.fields.relevantLinks.id, value: this.formData.relevantLinks },
                { id: this.fields.otherDetails.id, value: this.formData.otherDetails },
            ],
        };
        this.loading = true;
        this.$http
            .post(this.configuration.emailApiEndpoint, JSON.stringify(submitData))
            .then(function (response) {
            if (response.data.statusCode === 200) {
                _this.hideForm = true;
                _this.showSuccess = true;
                return;
            }
            else {
                if (response.data.message !== 'SimpleMath') {
                    _this.hideForm = true;
                    _this.showError = true;
                    return;
                }
                if (!_this.showSimpleMath) {
                    _this.vcRecaptchaService.reload(_this.reCaptchaWidgetId);
                    return;
                }
                _this.initSimpleMath(function () {
                    _this.showSimpleMathError = true;
                });
            }
        }, function () {
            _this.hideForm = true;
            _this.showError = true;
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    MissingDeviceComponentController.prototype.handleSupportedAudioConnections = function () {
        var audioConnections = this.selectedAudioConnections.filter(function (sac) { return sac !== 'Other'; }).join(', ');
        if (this.audioConnectionUserText) {
            audioConnections += ", Other: " + this.audioConnectionUserText;
        }
        return audioConnections;
    };
    MissingDeviceComponentController.prototype.handleProductType = function () {
        return this.productUserTypeText
            ? this.formData.selectedProductType + ": " + this.audioConnectionUserText
            : this.formData.selectedProductType;
    };
    MissingDeviceComponentController.prototype.setTranslations = function () {
        var _this = this;
        this.dictionary
            .get(contactInformationDictionaryKey)
            .then(function (translation) { return _this.contactInformationTitle = translation; });
        this.dictionary
            .get(missingDeviceDictionaryKey)
            .then(function (translation) { return _this.missingDeviceTitle = translation; });
        this.dictionary
            .get(pleaseSpecifyTextDictionaryKey)
            .then(function (translation) { return _this.pleaseSpecifyLabel = translation; });
        this.dictionary
            .get(versionInformationDictionaryKey)
            .then(function (translation) { return _this.versionInformationLabel = translation; });
        this.dictionary
            .get(emailDoesntMatchDictionaryKey)
            .then(function (translation) { return _this.emailDoesntMatchWarning = translation; });
        this.dictionary
            .get(checkAtLeastOneOptionDictionaryKey)
            .then(function (translation) { return _this.checkAtLeastOneOptionWarning = translation; });
    };
    MissingDeviceComponentController.$inject = ['$http', '$q', 'missingDeviceConfiguration', 'vcRecaptchaService', 'contentDictionary'];
    return MissingDeviceComponentController;
}(CaptchaController));
export var MissingDeviceComponent = {
    controller: MissingDeviceComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/forms/missingdevice',
};
